import { Component, OnInit } from '@angular/core';
import { WebSocketAPI} from './WebSocketAPI'
import { NotificationService, NotificationItem } from './notification.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css']
})
export class NotificationsComponent implements OnInit{

  constructor(private notificationService: NotificationService) { }
   webSocketAPI:WebSocketAPI;
  greeting: any;
  name: string;
  notifications: Array<NotificationItem> = [];
  private sub: Subscription;
  
  ngOnInit(){
    try {
      this.webSocketAPI = new WebSocketAPI(this);
    } catch (e) {
      console.warn("Failed to initialize WebSocket API:", e.message);
    }

    // Subscribe to shared notifications
    this.sub = this.notificationService.notifications$.subscribe(arr => {
      this.notifications = arr;
    });
  }
  connect(){
    this.webSocketAPI._connect();
  }

  disconnect(){
    this.webSocketAPI._disconnect();
  }

  sendMessage(){
    this.webSocketAPI._send(this.name);
  }

  handleMessage(message){
    this.greeting = message;
    try {
      const payload = typeof message === 'string' ? { message } : message;
      const entry: NotificationItem = {
        title: payload.title || 'Notification',
        body: payload.body || payload.message || JSON.stringify(payload),
        time: new Date()
      };
      // Add into shared service (will update all subscribers, including AppComponent)
      this.notificationService.addNotification(entry);
    } catch (e) {
      console.warn('Failed to add notification', e);
    }
  }

  ngOnDestroy(){
    if (this.sub) { this.sub.unsubscribe(); }
  }

}
